import { render, staticRenderFns } from "./PassMatrix.vue?vue&type=template&id=340051ed"
import script from "./PassMatrix.vue?vue&type=script&lang=js"
export * from "./PassMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports